import React from 'react';
import { Container, Typography, Paper, Box, Grid } from '@mui/material';
import Footer from '../components/common/Footer';
import Navbar from '../components/common/Navabar';

const PolicyPage = () => {
  return (
    <>
      <Navbar />
      <Container maxWidth="md" sx={{ marginTop: '2rem' }}>
        <Paper elevation={3} sx={{ padding: '2rem', backgroundColor: '#f9f9f9' }}>
          <Box sx={{ marginBottom: '2rem' }}>
            <Typography variant="h5" component="h2" gutterBottom>
              3. Privacy Policy
            </Typography>
            <Typography variant="body1">
              <strong>1. Introduction</strong><br />
              At <strong>QBus Rentals</strong>, we are committed to protecting your privacy and handling your personal data responsibly. This Privacy Policy explains how we collect, use, and protect your information when you use our services or visit our website.
            </Typography>
            <Typography variant="body1">
              <strong>2. Information We Collect</strong><br />
              - <strong>Personal Information</strong>: Name, email address, phone number, billing address, travel preferences, and payment details.<br />
              - <strong>Non-Personal Information</strong>: IP address, browser type, location data, and usage patterns.
            </Typography>
            <Typography variant="body1">
              <strong>3. How We Use Your Information</strong><br />
              We use your information for the following purposes:<br />
              - To process and manage your bookings and reservations.<br />
              - To communicate with you regarding your travel arrangements, including confirmations, changes, and promotions.<br />
              - To improve the quality of our services, website functionality, and user experience.<br />
              - To comply with legal and regulatory obligations.
            </Typography>
            <Typography variant="body1">
              <strong>4. Data Sharing</strong><br />
              We do not sell or rent your personal information to third parties. However, we may share it with trusted service providers who assist us in delivering our services, such as transportation providers, event organizers, and payment processors. These third parties are obligated to maintain confidentiality and protect your information.
            </Typography>
            <Typography variant="body1">
              <strong>5. Data Security</strong><br />
              We implement robust security measures to protect your personal information from unauthorized access or misuse. However, no data transmission method over the internet is 100% secure. We encourage you to take necessary precautions to protect your information.
            </Typography>
            <Typography variant="body1">
              <strong>6. Cookies</strong><br />
              Our website uses cookies to enhance your browsing experience. Cookies are small text files stored on your device that help us track your preferences. You can manage your cookie settings through your browser, but disabling cookies may affect website functionality.
            </Typography>
            <Typography variant="body1">
              <strong>7. Your Rights</strong><br />
              You have the right to access, correct, or delete the personal information we hold about you. If you wish to exercise these rights or have any privacy-related concerns, please contact us at support@yourcompany.com
            </Typography>
            <Typography variant="body1">
              <strong>8. Changes to the Privacy Policy</strong><br />
              We may update this Privacy Policy from time to time. Any updates will be posted on this page, and the revised policy will apply to any data collected after the update.
            </Typography>
          </Box>

          <Box sx={{ marginBottom: '2rem' }}>
            <Typography variant="h5" component="h2" gutterBottom>
              4. Refund Policy
            </Typography>
            <Typography variant="body1">
              <strong>1. General Policy</strong><br />
              At <strong>QBus Rentals</strong>, we aim to provide excellent service. However, if you are not satisfied with your booking or need to cancel, please refer to our refund policy for the applicable terms.
            </Typography>
            <Typography variant="body1">
              <strong>2. Cancellation and Refund Eligibility</strong><br />
              - <strong>Cancellation by the Customer</strong>: You can cancel your booking by contacting our customer service. Refund eligibility depends on the timing of the cancellation, as follows:<br />
              - <strong>Cancellation 7+ days before the trip</strong>: Full refund minus any applicable processing fees.<br />
              - <strong>Cancellation within 3-6 days before the trip</strong>: 50% refund of the total booking amount.<br />
              - <strong>Cancellation within 48 hours or after the trip has commenced</strong>: No refund.<br />
              - <strong>Cancellation by QBus Rentals</strong>: If we cancel or reschedule your trip due to unforeseen circumstances (e.g., mechanical failure, weather conditions), you are entitled to a full refund or the option to rebook at a later date.
            </Typography>
            <Typography variant="body1">
              <strong>3. Refund Process</strong><br />
              - To initiate a refund, you must contact our customer support team at support@yourcompany.com with your booking reference number and the reason for your cancellation.<br />
              - Approved refunds will be processed and credited within [2-3 business days] and issued to the original payment method used for booking.
            </Typography>
            <Typography variant="body1">
              <strong>4. Non-Refundable Fees</strong><br />
              Certain services or fees may be non-refundable, including but not limited to:<br />
              - Administration or processing fees<br />
              - Custom packages or services that have already been provided
            </Typography>
            <Typography variant="body1">
              <strong>5. Damaged or Defective Services</strong><br />
              If you encounter issues with the bus or other services, please report the issue to us immediately. If the service is defective or does not meet the agreed-upon conditions, we will offer a partial or full refund depending on the circumstances.
            </Typography>
            <Typography variant="body1">
              <strong>6. Changes to Refund Policy</strong><br />
              We reserve the right to modify or update our Refund Policy at any time. Any changes will be posted on our website and will apply to all future bookings.
            </Typography>
          </Box>
        </Paper>
      </Container>
      <Footer />
    </>
  );
};

export default PolicyPage;





{/* <Typography variant="h4" component="h1" align="center" gutterBottom>
Quotation, Cancellation, and Refund Policy
</Typography>

<Box sx={{ marginBottom: '2rem' }}>
<Typography variant="h5" component="h2" gutterBottom>
  1. Quotation Policy
</Typography>
<ul>
  <li className='mb-2'>
    <Typography variant="body1">
      Fares are calculated based on distance, duration, and applicable surcharges (e.g., driver charges and toll fees).
    </Typography>
  </li>
  <li className='mb-2'>
    <Typography variant="body1">
      Parking charges, and state entry taxes (if applicable) are to be borne by the customer.
    </Typography>
  </li>
  <li className='mb-2'>
    <Typography variant="body1">
      The quotation mentioned during the booking is specified based on the aforementioned. If the vehicle running exceeds the kilometres or exceeds the time duration as mentioned on the invoice, further charges will be applicable based on the vehicle booked. M/S Qbus Rentals does not take responsibility for trip extensions and its circumstances.
    </Typography>
  </li>
  <li>
    <Typography variant="body1">
      The M/S Qbus Rentals is responsible for collecting the advance amount only. The pending balance will be cash on vehicle and has to be collected by the vendor or vendor driver.
    </Typography>
  </li>
</ul>
</Box>

<Box sx={{ marginBottom: '2rem' }}>
<Typography variant="h5" component="h2" gutterBottom>
  2. Cancellation and Refund Policy
</Typography>

<Typography variant="h6" component="h3" gutterBottom>
  2.1 Customer Cancellation
</Typography>
<ul>
  <li className='mb-2'>
    <Typography variant="body1">
      Advance amount of 10% is needed for any vehicle booking.
    </Typography>
  </li>
  <li className='mb-2'>
    <Typography variant="body1">
      Cancellation greater than 30 days of the trip from the booking date will attract a cancellation fee of 50% of the advance amount.
    </Typography>
  </li>
  <li className='mb-2'>
    <Typography variant="body1">
      Cancellation less than 30 days of the trip from the booking date will attract a cancellation fee of 100% of the advance amount, i.e., no refund will be generated.
    </Typography>
  </li>
  <li className='mb-2'>
    <Typography variant="body1">
      If the customer does not show up for the trip, then no refund will be processed.
    </Typography>
  </li>
</ul>

<Typography variant="h6" component="h3" gutterBottom>
  2.2 Company Cancellation
</Typography>
<ul>
  <li className='mb-2'>
    <Typography variant="body1">
      If the vendor does not show up for the pickup, in such scenarios as an alternate solution, the company will provide a similar seating capacity vehicle based on the inventory available at the pickup location. In case, the inventory is not available at the pickup or nearby pickup location, a complete refund will be initiated on the advance amount.
    </Typography>
  </li>
  <li className='mb-2'>
    <Typography variant="body1">
      The company reserves the right to cancel a booking due to unforeseen circumstances such as extreme weather conditions, act of god, or war conditions.
    </Typography>
  </li>
</ul>
</Box> */}